// actions
import { ADDSTOPBTN_UPDATE_LABEL } from './actions';

const AddStopBtn = (state = {
  label: '',
}, action) => {
  switch (action.type) {
    case ADDSTOPBTN_UPDATE_LABEL:
      return {
        ...state,
        label: action.label,
      };
    default:
      return state;
  }
};

export default AddStopBtn;
